import { useSwitchLocalePath, useLocalePath, Route } from 'vue-i18n-routing';

export default function () {
  const router = useRouter();
  const localePath = useLocalePath();
  const u7SwitchLocalePath = useSwitchLocalePath();
  // switch 跳转
  const routerSwitch = (language: any, mode: 'replace' | 'push' = 'replace') => {
    router[mode](u7SwitchLocalePath(language));
  };
  // router 路由跳转
  const routerLocalePath = (route: Route, mode: 'replace' | 'push' = 'push') => {
    router[mode](decodeURIComponent(u7LocalePath(route)));
  };
  // router 解码
  const u7LocalePath = (route: Route) => {
    return decodeURIComponent(localePath(route));
  };
  return {
    u7LocalePath,
    u7SwitchLocalePath,
    routerSwitch,
    routerLocalePath
  };
}
